import { useQuery } from '@tanstack/react-query';

import { currentNavSnapshot, latestSnapshot, snapshotHistory } from '../../lib/api/endpoints';

export const snapshotKeys = {
  all: ['snapshots'] as const,
  latest: (accountId: string) => [...snapshotKeys.all, accountId, 'latest'] as const,
  current: () => [...snapshotKeys.all, 'current'] as const,
  history: (accountId: string, from: string, to: string) =>
    [...snapshotKeys.all, accountId, 'history', from, to] as const,
};

export function useLatestSnapshot(accountId: string | null) {
  return useQuery({
    queryKey: accountId ? snapshotKeys.latest(accountId) : [...snapshotKeys.all, 'none'],
    queryFn: () => latestSnapshot(accountId ?? ''),
    enabled: accountId !== null,
    staleTime: 30_000,
  });
}

export function useCurrentNavSnapshot(enabled: boolean) {
  return useQuery({
    queryKey: snapshotKeys.current(),
    queryFn: currentNavSnapshot,
    enabled,
    staleTime: 30_000,
  });
}

export function useSnapshotHistory(input: { accountId: string | null; from: string; to: string }) {
  return useQuery({
    queryKey: input.accountId
      ? snapshotKeys.history(input.accountId, input.from, input.to)
      : [...snapshotKeys.all, 'history', 'none'],
    queryFn: () =>
      snapshotHistory({ accountId: input.accountId ?? '', from: input.from, to: input.to }),
    enabled: input.accountId !== null,
    staleTime: 30_000,
  });
}
